import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Configuracoes } from 'src/app/entities/configuracoes';
import { ProductQuantityInputComponent } from '../product-quantity-input/product-quantity-input.component';
import { ConfiguracoesSite } from 'src/app/entities/configuracoesSite';

@Component({
  selector: 'app-product-image',
  templateUrl: './product-image.component.html',
  styleUrls: ['./product-image.component.css']
})
export class ProductImageComponent implements OnInit {

  @Input()
  public product: any;

  @Input()
  public height: string;

  @Input()
  public produtoDescrHeight: string;

  @Output()
  public onAdd = new EventEmitter<number>();

  @Output()
  public redirectTo = new EventEmitter<number>();

  @ViewChild('productQuantityInput', { read: ProductQuantityInputComponent, static: true })
  public productQuantityInput!: ProductQuantityInputComponent;

  public API_IMAGENS: string;
  public API_IMAGENS_PRODUTOS: string;
  public site: ConfiguracoesSite;
  public quantity: number;
  public rebate: number;

  constructor(private router: Router) {
    this.API_IMAGENS = Configuracoes.API_IMAGENS;
    this.API_IMAGENS_PRODUTOS = Configuracoes.API_IMAGENS_PRODUTOS;
    this.site = Configuracoes.SITE;
  }

  ngOnInit(): void {
    this.quantity = this.product.quantidade;
    this.rebate = this.product.desconto;
  }

  public updateQuantity(quantity) {
    this.product.quantidade = quantity;
    if (this.productQuantityInput)
      this.productQuantityInput.updateQuantity(quantity);
    this.ngOnInit();
  }
}
